import {
  CREATE_QUESTIONNAIRE,
  CREATE_QUESTIONNAIRE_SUCCESS,
  CREATE_QUESTIONNAIRE_FAILURE,
} from 'store/createQuestionnaire/createQuestionnairAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const postQuestionnaireReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_QUESTIONNAIRE:
      return { ...state, loading: true };
    case CREATE_QUESTIONNAIRE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case CREATE_QUESTIONNAIRE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default postQuestionnaireReducer;
